<template>
  <div class="loginForm" :class="{ canLogin }">
    <div class="inputBox phone">
      <slot name="p_icon"></slot>
      <input
        v-model="phone"
        type="text"
        @input="phoneChange"
        pattern="\d*"
        placeholder="请输入手机号码"
      />
      <div v-show="phone" @click="phone = ''" class="clear"></div>
    </div>
    <div v-if="graphCodeSrc" class="inputBox smsCode img-code">
      <slot name="s_icon"></slot>
      <input
        v-model="graphCode"
        maxlength="6"
        type="text"
        pattern="\w*"
        placeholder="请输入图形验证码"
      />
      <img class="code-image" @click="phoneChange" :src="graphCodeSrc" alt="" />
    </div>
    <div class="inputBox smsCode" :class="{ canSend }">
      <slot name="s_icon"></slot>
      <input
        v-model="sms_code"
        :maxlength="smsMaxLen"
        type="text"
        pattern="\d*"
        placeholder="请输入短信验证码"
      />
      <div
        @click="getSmsCode"
        class="sms"
        :style="{ color: smsTextColor, backgroundColor: smsBgColor }"
      >
        {{ smsText }}
      </div>
    </div>
    <slot name="agreement"></slot>
    <div @click="login" class="login" :style="{ backgroundColor: btnColor }">
      <slot></slot>
    </div>
    <div class="agree" v-if="showAgree">
      <span
        @click.prevent="toggleAgree"
        :class="{ checked: agree, unchecked: !agree }"
      ></span>
      我已阅读并同意平台<a
        class="pink"
        :href="privacyAndAgree[env]['agree']"
        target="_blank"
      >
        &nbsp;{{ privacyAndAgreeText.agree }}&nbsp;</a
      >及<a
        class="pink"
        :href="privacyAndAgree[env]['privacy']"
        target="_blank"
      >
        &nbsp;{{ privacyAndAgreeText.privacy }}
      </a>
    </div>
  </div>
</template>

<script>
/**
 * Components Usage
 * loginForm组件已在全局注册,
 * 使用时需在自己的login路由对应的组件中使用
 * 例如:
 * login.vue
 * <template>
 *  <loginForm>
 *    登录|| img || div.class
 *  </loginForm>
 * </template>
 * 考虑到活动登陆按钮样式较多,需自行编写登录按钮样式,
 * 编写的按钮html会自动通过slot插入form中
 * 外层绑定了登录按钮的点击事件,所以不需要自己额外定义事件
 * 接收一些参数用于改变验证码按钮背景色和字体颜色:
 * smsBgColor smsTextColor
 */
import {
  geetestInit,
  setStorage,
  getStorage,
  removeStorage,
  verifyPhone,
  genAccessTokenStr,
  starPhone
} from '@/utils';
import watchdog from '@hll/watch-dog-jsutil';
import { XL_ACCOUNT_TYPE, PRIVACYANDAGREE } from '@/utils/constants';
import { sendEvent } from '@/components/js/watchDog/custom';
import { UNIQUE_ID } from '@/components/js/watchDog/uniqueId';
import { mapState, mapMutations } from 'vuex';

export default {
  props: {
    btnColor: {
      type: String
      // this must no default
    },
    smsBgColor: {
      type: String,
      // this must have default bg color
      default: '#f16622'
    },
    smsTextColor: String,
    loginUrl: String,
    accountType: String
  },
  data() {
    return {
      smsType: null,
      phone: '',
      sms_code: '',
      graphCode: '',
      SMS_RND: '',
      smsHandler: '',
      smsText: '获取验证码',
      graphCodeSrc: null,
      isSmsSending: false, //是否正在发送验证码
      agree: false,
      privacyAndAgree: PRIVACYANDAGREE
    };
  },
  computed: {
    ...mapState('global', ['env', 'ref']),
    // 展示 xl 备案
    showRecord() {
      return this.accountType === XL_ACCOUNT_TYPE;
    },
    canSend() {
      if (this.smsType === 'graph') {
        return /^\d{11}$/g.test(this.phone) && /^\w{4}$/.test(this.graphCode);
      } else if (this.smsType === 'geetest') {
        return /^\d{11}$/g.test(this.phone);
      } else {
        return /^\d{11}$/g.test(this.phone);
      }
    },
    canLogin() {
      return this.phone && this.sms_code;
    },
    smsMaxLen() {
      if (this.env === 'company' || this.accountType === XL_ACCOUNT_TYPE) {
        return 4;
      } else {
        return 6;
      }
    },
    showAgree() {
      return this.accountType === XL_ACCOUNT_TYPE;
    },
    privacyAndAgreeText() {
      let driverContent = {
          privacy: '隐私协议',
          agree: '网约车司机合作协议'
        },
        userContent = {
          privacy: '隐私政策',
          agree: '用户服务协议'
        };
      return this.env == 'user' ? userContent : driverContent;
    }
  },
  created() {
    console.log(this.env, this.accountType, '123');
    //发短信的随机码
    let SMS_RND = getStorage('SMS_RND');
    if (!SMS_RND) {
      setStorage('SMS_RND', ~~(Math.random() * 900) + 100, 1440000);
    }
    this.SMS_RND = getStorage('SMS_RND');
    this.getSmsType();
  },
  methods: {
    ...mapMutations('global', ['set_env']),
    getSmsType() {
      this.$axios
        .get('/act/passport/verify_type')
        .then(data => {
          // default is php response, defaultType is java response.
          if (data.default === 'geetest' || data.defaultType === 'geetest') {
            this.smsType = 'geetest';
          } else if (data.default === 'graph') {
            this.smsType = 'graph';
          } else {
            this.smsType = 'graph';
          }
        })
        .catch(e => {
          sendEvent('LOGIN_VERIFY_TYPR_ERROR', e);
          this.$hll.toast(e.msg);
        });
    },
    phoneChange() {
      //电话号码输入时事件,当输入完成时,初始化极验
      if (/^\d{11}$/g.test(this.phone)) {
        if (this.smsType === 'geetest') {
          this.initGeet(); //初始化极验
        } else if (this.smsType === 'graph') {
          this.fetchGraph(this.phone);
        }
      } else {
        this.phone = this.phone.replace(/[^0-9]/g, '').slice(0, 11);
      }
    },
    countDown() {
      //验证码倒计时
      let s = 60;
      this.smsText = `发送中(${s}s)`;
      this.isSmsSending = true;
      let timer = setInterval(() => {
        this.smsText = `发送中(${--s}s)`;
        if (s == 0) {
          clearInterval(timer);
          this.smsText = `获取验证码`;
          this.isSmsSending = false;
        }
      }, 1000);
    },
    async getSmsCode() {
      //获取短信验证码
      if (this.isSmsSending) {
        return;
      }
      if (typeof this.smsHandler == 'function') {
        this.smsHandler();
      } else {
        let canSendSms = await this.initGeet();
        canSendSms && this.smsHandler();
      }
    },
    fetchGraph(phone) {
      this.$axios
        .get('/act/passport/graph', {
          params: {
            phone_no: phone
          },
          responseType: 'blob'
        })
        .then(data => {
          this.$hll.clearToast();
          var reader = new FileReader();
          if (/image/.test(data.type)) {
            reader.readAsDataURL(data);
            reader.onload = () => {
              this.graphCodeSrc = reader.result;
            };
          } else {
            this.graphCodeSrc = null;
          }

          this.smsHandler = () => {
            if (/^1\d{10}$/g.test(this.phone)) {
              this.sendSmsCode();
            } else {
              this.$hll.toast('请输入正确的手机号码');
            }
          };
        });
    },
    initGeet() {
      //极验初始化
      return new Promise(resolve => {
        if (!/^\d{11}$/g.test(this.phone)) {
          this.$hll.toast('请输入正确的手机号');
          resolve(false);
          return;
        }
        geetestInit(captchaObj => {
          this.smsHandler = () => {
            if (/^1\d{10}$/g.test(this.phone)) {
              captchaObj.verify();
            } else {
              this.$hll.toast('请输入正确的手机号码');
            }
          };
          captchaObj.onSuccess(() => {
            let result = captchaObj.getValidate();
            this.sendSmsCode({
              geetest_challenge: result.geetest_challenge,
              geetest_validate: result.geetest_validate,
              geetest_seccode: result.geetest_seccode
            });
          });
          captchaObj.onError(() => {
            //do something
          });
          captchaObj.onClose(() => {
            //do something
          });
          //定义成功后返回true
          resolve(true);
        }, this.phone);
        //5s后超时
        setTimeout(() => {
          resolve(false);
        }, 5000);
      });
    },
    sendSmsCode(appendParams = {}) {
      this.$axios
        .post(
          '/act/passport/send_sms_code',
          Object.assign(
            {
              phone_no: this.phone,
              verify_type: this.smsType,
              verify_code: this.graphCode,
              sms_rnd: this.SMS_RND
            },
            appendParams
          )
        )
        .then(data => {
          this.$hll.toast(data.msg);
          this.countDown(); //倒计时
        });
    },
    login() {
      let { invitationCode, code } = this.$route.params.redirectObject || {};
      // 小拉用户需要设置 同意协议
      if (this.showAgree) {
        if (!this.agree) {
          this.$hll.toast('请勾选协议');
          return;
        }
      }

      //登录
      if (!this.canLogin) {
        this.$hll.toast('请填写手机号和验证码');
        return;
      }

      let url = this.loginUrl ? this.loginUrl : '/act/passport/phone_in';
      if (verifyPhone(this.phone)) {
        this.$axios
          .post(url, {
            phone_no: this.phone,
            sms_code: this.sms_code,
            code,
            invitationCode,
            sms_rnd: this.SMS_RND,
            user_type: this.env
          })
          .then(e => {
            try {
              this.$sensors.login(e.hash_fid);
            } catch (err) {
              console.log(err);
              sendEvent('LOGIN_SENSOR_ERROR', err);
            }
            try {
              if (this.accountType === XL_ACCOUNT_TYPE) {
                this.visitLog('', '', {
                  actEventType: 'login_success',
                  url: location.href
                });
              }
              if (
                this.accountType === XL_ACCOUNT_TYPE &&
                this.env === 'user' &&
                e.newUser
              ) {
                this.visitLog('', '', {
                  actEventType: 'register_success',
                  web_url: location.href
                });
              }
            } catch (err) {
              console.log(err);
            }
            if (e.user_type) {
              this.set_env(e.user_type);
              setStorage(`act_user_type`, e.user_type);
            } else {
              removeStorage(`act_user_type`);
            }
            // different key by account type
            setStorage(genAccessTokenStr(this.accountType), e.access_token);
            sessionStorage.setItem('loged', '1'); // 存储登录状态
            sessionStorage.setItem('__mobile__', this.phone); // 存储手机号
            this.$emit('loged', true); //回调
            watchdog.setConfig({
              bizUserId: JSON.stringify({
                userId: e.hash_fid,
                uniqueId: UNIQUE_ID
              })
            });
            if (this.$route.params && this.$route.params.redirectObject) {
              this.$router.replace(this.$route.params.redirectObject);
            } else {
              this.$router.replace(`/`);
            }
          })
          .catch(e => {
            this.$emit('loged', false); //回调
            sendEvent('LOGIN_FORM_FAILED_ERROR', e, {
              phone: starPhone(this.phone),
              code: this.sms_code
            });

            if (e.ret == 8008) {
              setTimeout(() => {
                location.href = `https://dappweb.huolala.cn/driver-join/?ref=${this
                  .ref || 'act2_common_login'}`;
              }, 2000);
            }
          });
      }
    },
    toggleAgree() {
      this.agree = !this.agree;
    }
  }
};
</script>

<style lang="less" scoped>
.loginForm {
  flex-shrink: 0;
  margin-top: 625px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  & > div {
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 18px;
    padding: 0 10px;
    box-sizing: border-box;
    width: 617px;
    height: 96px;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 10px;

    input {
      flex: 1;
      padding: 20px 0;
      box-sizing: border-box;
    }
  }

  & > .agree {
    justify-content: flex-start;
    // align-items: flex-start;
    font-size: 22px;
    // margin-top: 40px; // 96

    & > .checked {
      width: 30px;
      height: 30px;
      background: center / 21px 21px url('../assets/common/checked.png')
        no-repeat;
    }

    & > .unchecked {
      width: 30px;
      height: 30px;
      // background-size: ;
      background: center / 21px 21px url('../assets/common/no_check.png')
        no-repeat;
    }

    .pink {
      color: #ff4553;
    }
  }

  .sms {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 175px;
    height: 76px;
    border-radius: 10px;
    font-size: 24px;
    font-weight: 300;
    color: rgba(242, 242, 242, 1);
  }

  .img-code {
    img.code-image {
      height: 67px;
      width: auto;
    }
  }

  .clear {
    width: 32px;
    height: 32px;
    background-size: 100% 100%;
    background-image: url(../assets/common/ic_clear.png);
  }

  .login {
    margin-top: 35px;
    justify-content: center;
    min-width: 624px;
    min-height: 96px;
    border-radius: 4px;
    font-size: 32px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    background-color: transparent;

    * {
      flex-shrink: 0;
    }
  }
}

.smsCode {
  .sms {
    width: 176px;
    height: 72px;
    opacity: 0.2;
    border-radius: 4px;
    background-color: #f16622;
  }
  &.canSend {
    .sms {
      background-color: #f16622;
      opacity: 1;
    }
  }
}
</style>
